"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PriceSourceEnum = void 0;
var PriceSourceEnum;
(function (PriceSourceEnum) {
    PriceSourceEnum["NET_PRICE"] = "netPrice";
    PriceSourceEnum["TAX_PRICE"] = "taxPrice";
    PriceSourceEnum["GROSS_PRICE"] = "grossPrice";
})(PriceSourceEnum || (exports.PriceSourceEnum = PriceSourceEnum = {}));
